import React from 'react';
import PropTypes from 'prop-types';
import LocationCheckbox from '../LocationCheckbox';

const CheckboxColumn = ({
  className,
  primary,
  allLocations,
  selectedLocations,
  onCheckboxChange,
  disabled,
}) => (
  <div className={className}>
    {allLocations.map(({ code, name }) => (
      <LocationCheckbox
        key={code}
        checked={Boolean(selectedLocations[code])}
        onChange={onCheckboxChange}
        primary={primary}
        code={code}
        name={name}
        disabled={disabled}
      />
    ))}
  </div>
);

CheckboxColumn.propTypes = {
  className: PropTypes.string,
  primary: PropTypes.string,
  allLocations: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedLocations: PropTypes.shape({}),
  onCheckboxChange: PropTypes.func,
  disabled: PropTypes.bool,
};

CheckboxColumn.defaultProps = {
  className: null,
  primary: null,
  selectedLocations: {},
  onCheckboxChange: null,
  disabled: false,
};

export default CheckboxColumn;
